import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import type { FC } from 'react';
import { getTracingEvents } from 'utils/amplitude';
import type { RadioGroupsProps } from './RadioGroups.types';
import { customRadioGroupsTypeMap } from './RadioGroups.types';

const themes = {
  bank: 'text-bank focus:ring-bank-200 focus:border-bank',
  expenses: 'text-expenses focus:ring-expenses-200 focus:border-expenses',
  revenues: 'text-revenues focus:ring-revenues-200 focus:border-revenues ',
  taxes: 'text-taxes focus:ring-taxes-200 focus:border-taxes',
  primary: 'text-primary focus:ring-primary-200 focus:border-primary',
};

const RadioGroups: FC<RadioGroupsProps> = ({
  type,
  legendLabel = 'Radio Group Options',
  data,
  onChange,
  labelClassNames = 'text-sm text-gray-700',
  className,
  tracing,
  descriptionClassNames,
  getHTMLLabelClasses,
}) => {
  const { inlineClasses } =
    customRadioGroupsTypeMap[type] || customRadioGroupsTypeMap.default;

  const theme = useWorldTheme();

  const tracingEvents = getTracingEvents(tracing, { onChange });

  return (
    <fieldset>
      <legend className="sr-only">{legendLabel}</legend>
      <div className={classNames('space-y-2', inlineClasses, className)}>
        {data.map(
          ({
            id,
            title,
            description,
            InfoComponent = () => null,
            checked,
            onClick,
          }) => (
            <label
              key={String(id)}
              className={classNames(
                'items-center flex cursor-pointer',
                getHTMLLabelClasses?.(!!checked),
              )}
              onClick={onClick}
            >
              <div className="flex items-center">
                <input
                  type="radio"
                  // name={String(`${idPrefix || ''}${id}`)}
                  // id={String(`${idPrefix || ''}${id}`)}
                  checked={!!checked}
                  className={classNames(
                    'cursor-pointer h-4 transition-colors tranisiton-shadow w-4 border-primary-200 hover:border-primary-400 allow-focus-shadow focus:ring-offset-0',
                    themes[theme],
                  )}
                  onChange={() => tracingEvents.onChange(id)}
                />
              </div>

              <span
                className={classNames(
                  'pl-3 flex-1 block font-medium cursor-pointer',
                  labelClassNames,
                )}
              >
                <p className={classNames('text-primary')}>{title}</p>
                {description && (
                  <p
                    className={classNames(
                      'text-sm font-medium text-primary',
                      descriptionClassNames,
                    )}
                  >
                    {description}
                  </p>
                )}
              </span>

              <InfoComponent />
            </label>
          ),
        )}
      </div>
    </fieldset>
  );
};

export default RadioGroups;
